import React from "react";
import './../../assets/styles/common/logo.css'
import logo from './../../assets/logo/Pontis Global Logo - Mark Only.svg'

const Logo = () => {
  return (
    <React.Fragment>
      <img src={logo} className="app-logo" alt="Pontis DMS" />
      <span id="title">Document Management System</span>
    </React.Fragment>
  );
};

export default Logo;
